/* eslint-disable  react/display-name*/
import { Grid, IconButton, Tooltip, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import Divider from "@mui/material/Divider";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { SaleUtils } from "../../../utils/SaleUtils";
import { StringUtils } from "../../../utils/StringUtils";
import API from "../../../utils/API";

export default function ProductIngredients(props) {
  const { t } = useTranslation();
  const translate = t;
  const [prodLookupValue, setProdLookupValue] = useState();
  const [summaryViewOpen, setSummaryViewOpen] = useState(false);
  const [totalCost, setTotalCost] = useState();
  const [costingMethods, setCostingMethods] = useState();
  const [product, setProduct] = useState([]);

  const [uomOptions, setUomOptions] = useState([
    {
      name: "Gram",
      id: "Gram",
      conversionValue: 1000,
    },
    {
      name: "KG",
      id: "KG",
      conversionValue: 1,
    },
    {
      name: "Milli",
      id: "Milli",
      conversionValue: 1000,
    },
    {
      name: "Count",
      id: "Count",
      conversionValue: 1,
    },
  ]);

  useEffect(() => {
    if (props.tableMeta) {
      showProductIngredientsView(props.tableMeta);
    }
  }, []);

  async function showProductIngredientsView(tableMeta) {
    let ingredientsList = [];
    let tempIngredientsList = [...tableMeta.tableData[tableMeta.rowIndex][15]];
    for (let i = 0; i < tempIngredientsList.length; i++) {
      let item = tempIngredientsList[i];
      ingredientsList.push([
        { v: ingredientsList.length + 1 },
        { v: item.productName },
        { v: item.unitTypeName },
        { v: item.productCode },
        {
          v: {
            name: item.uomName,
            id: item.uomId,
            conversionValue: item.conversionValue,
          },
        },
        { v: item.quantity },
        {
          info: {
            productBean: await getProductBeanById(item.productId),
            pricingBean: await getPricingBeanByUnitType(
              item.productId,
              item.unitType
            ),
          },
        },
      ]);
    }
    props.setIngredientsList(ingredientsList);
  }

  async function getProductBeanById(id) {
    let dbData = await db.product.where("id").equals(id).toArray();
    if (dbData && dbData[0]) {
      return dbData[0];
    } else {
      console.log("ERROR-", "Product not found! ID-", id);
      return null;
    }
  }

  async function getPricingBeanByUnitType(productId, unitType) {
    let dbData = await db.product.where("id").equals(productId).toArray();
    if (dbData && dbData[0] && dbData[0].productPricingBeanList) {
      for (let i = 0; i < dbData[0].productPricingBeanList.length; i++) {
        if (dbData[0].productPricingBeanList[i].unitType === unitType) {
          return dbData[0].productPricingBeanList[i];
        }
      }
    }
    console.log(
      "ERROR-",
      "Product pricing is not found! Product ID-",
      productId,
      " Unit Type-",
      unitType
    );
    return null;
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function getOptionsAsync(inputValue, callback) {
    let dbData = await db.product
      .where("name")
      .startsWithIgnoreCase(inputValue)
      .or("code")
      .startsWithIgnoreCase(inputValue)
      .or("barcodeList")
      .equals(inputValue)
      .limit(10)
      .toArray();

    let arr = [];
    let count = 0;
    for (let i = 0; i < dbData.length; i++) {
      for (let j = 0; j < dbData[i].productPricingBeanList.length; j++) {
        if (count < 10) {
          if (dbData[i].productType == "I") {
            let val = {
              id: dbData[i].id,
              name: dbData[i].name,
              code: dbData[i].code,
              price: dbData[i].productPricingBeanList[j].price,
              unitType: dbData[i].productPricingBeanList[j].unitType,
              factor: dbData[i].productPricingBeanList[j].factor,
              bean: dbData[i],
              pricingBean: dbData[i].productPricingBeanList[j],
            };
            arr.push(val);
            count++;
          }
        } else {
          break;
        }
      }
    }

    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );
  }

  const handleClose = () => {
    setSummaryViewOpen(!summaryViewOpen);
  };

  async function calculations() {
    setTotalCost(0.0);
    let stockList;
    let data = [];
    let total = 0;
    let cost = 0;
    let quantity = 0;
    let costMethod = await SaleUtils.getStoreCostingMethodeCode();
    setCostingMethods(costMethod);

    for (let d of props.ingredientsList) {
      {
        try {
          let { data } = await API.get(
            "/api/v1/stock/" + d[6].info.productBean.stockBean.id
          );
          stockList = data;
        } catch (err) {
          if (err.response && err.response.status == 404) {
            props.showMessage("warning", translate("No batches found!"));
          } else {
            props.showMessage(
              "error",
              translate("Not able to retrive batch info from server")
            );
          }
        }
      }
      quantity = parseFloat(d[5].v / d[4].v.conversionValue);
      cost = await SaleUtils.getProductCostFromBatchWithQty(
        stockList.stockBatchList,
        costMethod,
        parseFloat(d[6].info.pricingBean.cost / d[6].info.pricingBean.factor),
        quantity,
        props.context,
        props.context.store.currencyDecimal
      );
      setTotalCost((total = total + parseFloat(cost * quantity)));
      let i = [
        {
          name: d[1].v,
          quantity: quantity.toFixed(3),
          uom: d[4].v.name,
          cost: cost * quantity,
        },

        ,
      ];
      data.push(i);
    }
    setProduct(data);
  }

  const productLookupChanged = (newValue) => {
    addProductToTable(newValue.value.bean, newValue.value.pricingBean);
    setProdLookupValue({ label: null, value: null });
  };

  async function addProductToTable(productBean, pricingBean) {
    var data = [...props.ingredientsList];
    let sn = data.length + 1;

    let orderItem = [
      { v: sn },
      { v: productBean.name },
      { v: pricingBean.unitType },
      { v: productBean.code },
      { v: { name: "KG", id: "KG", conversionValue: 1 } },
      { v: 1 },
      {
        info: {
          productBean: productBean,
          pricingBean: pricingBean,
        },
      },
    ];
    data.push(orderItem);
    props.setIngredientsList(data);
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];
    data.splice(tableMeta.rowIndex, 1);
    props.setIngredientsList(data);
  }

  function updateData(eventSource, meta, value, index) {
    let dat = [...props.ingredientsList];
    dat[meta.rowIndex][index] = value;
    props.setIngredientsList(dat);
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 200 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "unit",
      label: "Unit",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productCode",
      label: translate("Product Code"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "unitOfMessurment",
      label: translate("UOM"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 200 }}>
            <PSelect
              options={uomOptions}
              value={value.v}
              onChange={(event, newValue) => {
                updateData(
                  "table",
                  tableMeta,
                  {
                    v: {
                      name: newValue.name,
                      id: newValue.id,
                      conversionValue: newValue.conversionValue,
                    },
                  },
                  4
                );
              }}
            ></PSelect>
          </div>
        ),
      },
    },
    {
      name: "qty",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 140 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" },
                  5
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 270,
  };

  async function onSave() {
    let ingredientsList = [];
    props.ingredientsList.map((item) => {
      let saveObject = Object.create(null);
      saveObject.productName = item[1].v;
      saveObject.productCode = item[3].v;
      saveObject.unitTypeName = item[6].info.pricingBean.unitTypeName
        ? item[6].info.pricingBean.unitTypeName
        : item[6].info.pricingBean.unitType;
      saveObject.unitType = item[6].info.pricingBean.unitType;
      saveObject.uomId = item[4].v.id;
      saveObject.uomName = item[4].v.name;
      saveObject.conversionValue = item[4].v.conversionValue;
      saveObject.quantity = item[5].v;
      saveObject.productId = item[6].info.productBean.id;
      ingredientsList.push(saveObject);
    });
    let tempPricingData = [...props.tableMeta.tableData];
    tempPricingData[props.tableMeta.rowIndex][15] = ingredientsList;
    props.setPricingData(tempPricingData);
    props.showMessage("success", translate("Saved sucessfully"));
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <AsyncSelect
            formatOptionLabel={formatOptionLabel}
            components={{ formatOptionLabel }}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 99999,
              }),
              marginRight: "10px",
            }}
            placeholder="Product Lookup"
            loadOptions={getOptions}
            onChange={productLookupChanged}
            onKeyDown={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }}
            value={prodLookupValue}
          />
        </Grid>
        <Grid item xs={12}>
          <MUIDataTable
            data={props.ingredientsList}
            columns={columns}
            options={options}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            width: "95%",
            position: "absolute",
            bottom: 20,
          }}
        >
          <Divider />
          <table width="100%">
            <tbody>
              <tr>
                <td width="95%"></td>
                <td>
                  <Button
                    style={{ marginTop: "5px" }}
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid>
          <Tooltip title={"Costing Details"}>
            <IconButton
              style={{ marginRight: "15%" }}
              color="primary"
              onClick={(event) => {
                calculations();
                setSummaryViewOpen(true);
              }}
            >
              <InfoOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Popover
            open={summaryViewOpen}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "center",
              horizontal: Number(370),
            }}
          >
            <Card style={{ marginTop: 5 }}>
              <CardContent style={{ backgroundColor: "#f5f4f2" }}>
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <b>{translate("Costing Details")}</b>
                </Typography>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td>{translate("Costing Method")}</td>
                      <td>:</td>
                      <td
                        style={{
                          paddingLeft: "35px",
                        }}
                      >
                        {costingMethods}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  width="100%"
                  style={{
                    width: "100%",
                    border: "1px solid black",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    <tr>
                      <th
                        style={{
                          border: "1px solid black",
                          borderCollapse: "collapse",
                          textAlign: "left",
                        }}
                      >
                        Item
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          borderCollapse: "collapse",
                          textAlign: "left",
                          paddingRight: "20px",
                        }}
                      >
                        Unit Type
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          borderCollapse: "collapse",
                          textAlign: "right",
                          paddingLeft: "20px",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          borderCollapse: "collapse",
                          textAlign: "right",
                          paddingLeft: "20px",
                        }}
                      >
                        Unit Cost
                      </th>
                    </tr>
                    {product.map(
                      (item) =>
                        item && (
                          <tr>
                            <td
                              style={{
                                textAlign: "left",
                                border: "1px solid black",
                                borderCollapse: "collapse",
                                paddingRight: "20px",
                              }}
                            >
                              {item[0].name}
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                border: "1px solid black",
                                borderCollapse: "collapse",
                                paddingRight: "30px",
                              }}
                            >
                              {item[0].uom}
                            </td>
                            <td
                              style={{
                                textAlign: "right",
                                border: "1px solid black",
                                borderCollapse: "collapse",
                              }}
                            >
                              {item[0].quantity}
                            </td>

                            <td
                              style={{
                                textAlign: "right",
                                border: "1px solid black",
                                borderCollapse: "collapse",
                                paddingLeft: "11px",
                              }}
                            >
                              {StringUtils.formattedNumber(
                                item[0].cost,
                                props.context.store.currencyDecimal
                              )}
                            </td>
                          </tr>
                        )
                    )}
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          paddingLeft: "15px",
                          border: "1px solid black",
                          borderCollapse: "collapse",
                        }}
                      >
                        <b>Total Derived Cost</b>
                      </td>

                      <td
                        style={{
                          textAlign: "right",
                          border: "1px solid black",
                          borderCollapse: "collapse",
                        }}
                        colSpan={3}
                      >
                        <b>
                          {StringUtils.formattedNumber(
                            totalCost,
                            props.context.store.currencyDecimal
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CardContent>
            </Card>
          </Popover>
        </Grid>
      </Grid>
    </div>
  );
}
